import React, { Component } from "react";
import CommonHeader from "../common/CommonHeader";
import CommonFooter from "../common/CommonFooter";
import CommonFooterNav from "../common/CommonFooterNav";
import { Swiper, SwiperSlide } from "swiper/react";
import tilledArrow from '../../../assets/images/tilled-arrow.svg';
import weWorkImg from '../../../assets/images/we-work-img.png';
import assetImg from '../../../assets/images/asset-img.png';
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper";

class AboutUs extends Component {
  constructor(props) {
    super(props);

    this.state = {
        
    };
  }

  render() {
    return (
    <main className="Brandmainpage about-us-page">
    <CommonHeader />
      <section>
        <div className="container-fluid p-0">
            <section className="home-banner-slider banner">
                <Swiper
                slidesPerView={1}
                slidesPerGroup={1}
                loop={true}
                loopFillGroupWithBlank={true}
                pagination={{
                clickable: true,
                }}
                navigation={false}
                modules={[Navigation,Pagination]}
                className="mySwiper"
                breakpoints={{
                "@0.00": {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                "@0.75": {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                "@1.00": {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                "@1.50": {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                }}
            >
                <SwiperSlide style={{backgroundImage: `url('https://d1cdvv6igb2e7g.cloudfront.net/jodit/oh_69687756ab0bc69687756ab0bd.jpg')`,backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat',}}>
                <div className="container d-flex align-items-start flex-column justify-content-center h-100 w-100 pd-l-25 pd-r-25">
                    <div className="content">
                    <div className="content-center text-start">
                        <h1>
                        Premium Lounge / Workspace
                        </h1>
                        <span>
                        Customizable Solutions for Modern Properties
                        </span>
                    </div>
                    </div>
                </div>
                </SwiperSlide>
                <SwiperSlide style={{backgroundImage: `url('https://d1cdvv6igb2e7g.cloudfront.net/jodit/oh_696877740769b696877740769c.jpg')`,backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat',}}>
                <div className="container d-flex align-items-start flex-column justify-content-center h-100 w-100 pd-l-25 pd-r-25">
                    <div className="content">
                    <div className="content-center text-start">
                        <h1>
                        Premium Lounge / Workspace
                        </h1>
                        <span>
                        Customizable Solutions for Modern Properties
                        </span>
                    </div>
                    </div>
                </div>
                </SwiperSlide>
                <SwiperSlide style={{backgroundImage: `url('https://d1cdvv6igb2e7g.cloudfront.net/jodit/oh_696877d20e81a696877d20e81b.png')`,backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat',}}>
                <div className="container d-flex align-items-start flex-column justify-content-center h-100 w-100 pd-l-25 pd-r-25">
                    <div className="content">
                    <div className="content-center text-start">
                        <h1>
                        Premium Lounge / Workspace
                        </h1>
                        <span>
                        Customizable Solutions for Modern Properties
                        </span>
                    </div>
                    </div>
                </div>
                </SwiperSlide>
                </Swiper>
            </section>
        </div>
      </section>

      <section className="revenue-modern-section">
        <div className="container-fluid">
            <div className="row justify-content-center">
                <div className="col-md-12 col-lg-10">
                    <h3>Modern buildings deserve modern revenue.</h3>
                    <div className="rev-content-box">
                        <p>OHAI is an enterprise software platform that empowers property owners to unlock revenue from unoccupied space. We specialize in monetizing unleased apartments, parking spaces, and storage—turning idle assets into accretive income with minimal effort.</p>
                        <p>Our technology is fully customizable to each client’s operational model and can support apartments, office suites, parking, and storage on an hourly, daily, monthly, or annual basis. Everything is dynamically managed in real time, allowing instant updates to availability, pricing, and access.</p>
                        <p>We are a small team of industry experts who lead with technology and deliver with ease. Our clients are private, innovative, entrepreneurial owners of primarily Class A multifamily assets. While we excel in STR-friendly communities, we’ve expanded our capabilities to monetize a broader mix of space types.</p>
                        <p>At OHAI, we work quietly in the background. We are a service-first software company—the less you need to see or hear from us, the better.</p>
                        <p>And that’s only the beginning. Behind the scenes, we handle thousands of micro-tasks—making the complex feel invisible so your operations run effortlessly.</p>
                    </div>
                </div>
            </div>
        </div>
      </section>

      <section className="ocar-section">
        <div className="container-fluid">
            <div className="row justify-content-center">
                <div className="col-md-12 col-lg-10">
                    <div className="row">
                        <div className="col-md-12 col-lg-5 position-relative">
                            <h3>
                                Simple, Seamless, Scalable.
                            </h3>
                            <p className="process-desc">
                                Our four-step process is designed for maximum efficiency and immediate revenue impact, with our team handling the complexity behind the scenes.
                            </p>
                            <div className="arrow-circle">
                                <img src={tilledArrow} alt="Arrow Icon" />
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-7 process-card-col">
                            <div className="row gx-4 gy-5">
                                 <div className="col-md-6">
                                    <div className="process-card">
                                        <div className="step-no">01</div>
                                        <h3>Onboarding</h3>
                                        <p>We assess your property's assets <span>and STR readiness.</span></p>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="process-card">
                                        <div className="step-no">02</div>
                                        <h3>Configuration</h3>
                                        <p>Custom rules for monetization, operations, and compliance.</p>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="process-card">
                                        <div className="step-no">03</div>
                                        <h3>Activation</h3>
                                        <p>Listings, pricing, access, and tax <span>routing go live.</span></p>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="process-card">
                                        <div className="step-no">04</div>
                                        <h3>Revenue</h3>
                                        <p>You earn. We handle the operational <span>load behind the scenes.</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>

      <section className="background-work-section">
        <div className="container-fluid">
            <div className="row justify-content-center">
                <div className="col-md-11 col-lg-10">
                    <div className="background-work-content">
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <div className="image-frame">
                                <img
                                    src={weWorkImg}
                                    alt="Room"
                                    className="img-fluid"
                                />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="back-work-st-content">
                                    <h3>We Work in the Background So Your Team Doesn't Have To</h3>
                                    <p>
                                    OHAI is a service-first platform built around invisible operations.
                                    We manage thousands of micro-tasks so your building stays seamless,
                                    your revenue grows, and your team stays focused.
                                    </p>
                                    <div className="row mt-4">
                                        <div className="col-md-6">
                                            <ul className="feature-list">
                                                <li>Digital access</li>
                                                <li>Security + monitoring</li>
                                                <li>Cleaning coordination</li>
                                                <li>Revenue management</li>
                                            </ul>
                                        </div>
                                        <div className="col-md-6">
                                            <ul className="feature-list">
                                                <li>Guest vetting</li>
                                                <li>Tax remittance</li>
                                                <li>Marketing + distribution</li>
                                                <li>Owner financial reporting</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>

      <section className="asset-section">
        <div className="container-fluid">
            <div className="row justify-content-center">
                <div className="col-md-9 col-lg-7">
                    <div className="row align-items-start gx-5">
                        <div className="col-md-6">
                            <h3 className="text-start">Built for Every Asset Type</h3>
                            <p className="text-start">Flexible and universal, our system adapts to every asset type, making management faster, easier, and more accurate.</p>
                            <div className="asset-image">
                                <img src={assetImg} alt="Asset Image" className="img-fluid" />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="asset-right-card">
                                <div className="asset-card">
                                    <h3>Multifamily Leasing</h3>
                                    <p>Monetize idle units automatically between long-term leases.</p>
                                </div>
                                <div className="asset-card">
                                    <h3>Flexible Work Models</h3>
                                    <p>Support short-term, long-term, or hybrid work models.</p>
                                </div>
                                <div className="asset-card">
                                    <h3>STR-Enabled Units</h3>
                                    <p>Fully compliant, fully managed short-term rental operations.</p>
                                </div>
                                <div className="asset-card">
                                    <h3>Parking Management</h3>
                                    <p>Dynamic pricing & digital access for unused parking spots.</p>
                                </div>
                                <div className="asset-card">
                                    <h3>Storage Optimization</h3>
                                    <p>Rent unused building storage space on flexible terms.</p>
                                </div>
                                <div className="asset-card">
                                    <h3>Amenity Access</h3>
                                    <p>Monetize pools, gyms, and conference rooms by the hour.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>

      <CommonFooter showSubscribe={true} showFooterBottom={false}/>
        <footer className="footer-nav-sec">
            <CommonFooterNav />
        </footer>
    <CommonFooter showSubscribe={false} showFooterBottom={true} />
    </main>
    );
  }
}

export default AboutUs;
